// extracted by mini-css-extract-plugin
export default {"dash":"EditConfigModal_dash__uwyeT","info_box":"EditConfigModal_info_box__-Gbku","icon_sty":"EditConfigModal_icon_sty__fuR6t"};